module.exports = "<div id=\"main\" [class.open]=\"openToast\" [class]=\"toast.type\">\n  <div class=\"icon\">\n    <i class=\"oi oi-check\"></i>\n    <i class=\"oi oi-x\"></i>\n    <i class=\"oi oi-bullhorn\"></i>\n  </div>\n  <div class=\"body\">\n    <span class=\"content\">{{ toast.content }}</span>\n    <i class=\"oi oi-x close-toast pull-right\" (click)=\"dismissToast()\"></i>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/toast/toast.template.html
// module id = ../../../../../src/app/shared/components/toast/toast.template.html
// module chunks = 12